module.exports = __webpack_public_path__ + "static/dots_work-11a3e7c27c283aade283b7bad9532094.png";